<template>
    <button
        type="button"
        class="forms__field_input--wysiwyg__button"
        :class="{
            'forms__field_input--wysiwyg__button--active': active,
            'forms__field_input--wysiwyg__button--disabled': disabled,
            'forms__field_input--wysiwyg__button--highlight': highlight,
        }"
    >
        <slot></slot>
    </button>
</template>

<script setup lang="ts">
import { toRef } from 'vue';

interface Props {
    active?: boolean;
    disabled?: boolean;
    highlight?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
    active: false,
    disabled: false,
    highlight: false,
});

const active = toRef(props, 'active');
const disabled = toRef(props, 'disabled');
const highlight = toRef(props, 'highlight');
</script>
